import thunk from 'redux-thunk'
import { createStore, applyMiddleware, combineReducers } from 'redux'
import { reducer as schulteLettersReducer, NAME as SCHULTELETTERS_NAME } from './modules/SchulteLetters/reducer'
import { reducer as wordPairsReducer, NAME as WORD_PAIRS_NAME } from './modules/WordPairs/reducer'
import { reducer as letterGridSearch, NAME as GRID_SEARCH_NAME } from './modules/GridSearch/reducer'
import { reducer as dashboard, NAME as DASHBOARD_NAME } from './modules/Dashboard/reducer'
import { reducer as wpmTest, NAME as WPM_TEST_NAME } from './modules/WPMTest/reducer'

const appReducer = combineReducers({
  [SCHULTELETTERS_NAME]: schulteLettersReducer,
  [WORD_PAIRS_NAME]: wordPairsReducer,
  [GRID_SEARCH_NAME]: letterGridSearch,
  [DASHBOARD_NAME]: dashboard,
  [WPM_TEST_NAME]: wpmTest,
})

const store = createStore(
  appReducer,
  applyMiddleware(thunk)
)

export default store
